module.exports = __webpack_public_path__ + "14c7c5f317ce20b0e8fa94e0e07946cd.pdf";